import apiClient from "./axios";

const profileApi = {
  // GET current user's profile (array → take first)
  getMyProfile: async () => {
    const response = await apiClient.get("/profile/");
    return response.data[0]; // API returns array, we use first object
  },

  // PATCH profile image
  updateProfile: async (employeeId, file) => {
    const form = new FormData();
    form.append("profile_img", file);

    const response = await apiClient.patch(`/employees/${employeeId}/`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  // GET security answers
  getSecurityAnswers: async (employeeId) => {
    const response = await apiClient.get(
      `/password-answers/?employee=${employeeId}`
    );
    return response.data;
  },

  // BULK UPDATE answers
  bulkUpdateAnswers: async (payload) => {
    const response = await apiClient.patch(
      "/password-answers/bulk-update/",
      payload
    );
    return response.data;
  },

  /* -------------------------- CHANGE PASSWORD -------------------------- */
  changePassword: async ({ old_password, new_password, confirm_password }) => {
    const response = await apiClient.post("/change-password/", {
      old_password,
      new_password,
      confirm_password,
    });
    return response.data;
  },
};

export default profileApi;
